import { Search, Bell, Plus } from "lucide-react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

export default function Topbar({ title, subtitle, actions, showLogoMark = false }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
      <div className="flex items-start gap-4">
        {showLogoMark && (
          <img
            src="https://customer-assets.emergentagent.com/job_salon-studio-pro-2/artifacts/7kyv63p4_LOGO%20LAKA%20CLUB%20BEAUTY.webp"
            alt=""
            aria-hidden="true"
            data-testid="topbar-logo-mark"
            className="hidden md:block w-16 h-16 object-contain opacity-70"
          />
        )}
        <div>
          <div className="laka-eyebrow" data-testid="page-eyebrow">LAKA Business Studio</div>
          <h1 className="font-display text-4xl sm:text-5xl mt-2 leading-none" data-testid="page-title">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm mt-3 max-w-xl" style={{ color: "var(--laka-text)" }}>
              {subtitle}
            </p>
          )}
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className="hidden md:flex items-center gap-2 laka-card px-3 py-2 w-72">
          <Search size={16} strokeWidth={1.25} style={{ color: "var(--laka-text)" }} />
          <Input
            data-testid="global-search-input"
            placeholder="Buscar cliente, cita, servicio…"
            className="border-0 shadow-none focus-visible:ring-0 h-7 px-0 bg-transparent text-sm"
          />
        </div>
        <Button
          data-testid="topbar-notifications"
          variant="ghost"
          size="icon"
          className="rounded-full border border-[#E8DFD1] hover:bg-[#E8DFD1]"
        >
          <Bell size={16} strokeWidth={1.25} />
        </Button>
        {actions}
      </div>
    </div>
  );
}

export function PrimaryAction({ label, onClick, testId }) {
  return (
    <Button
      data-testid={testId}
      onClick={onClick}
      className="laka-btn-primary rounded-md h-10 px-5 text-sm font-medium"
    >
      <Plus size={16} strokeWidth={1.5} className="mr-1" />
      {label}
    </Button>
  );
}
